/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'jquery',
	'../../../lib/@waca/dashboard-common/dist/ui/AuthoringToolbar'
], function ($, AuthoringToolbar) {
	'use strict';

	/*
	* This class override the AuthoringToolbar default behaviours so that the toolbar 
	* can synchronize the re-rendering of the DataSlotsView when the toolbar/flyout get 
	* destroy(removed)
	*
	*/
	class DataSlotsViewAuthoringToolbar extends AuthoringToolbar {
		constructor(options) {
			super(options);
			DataSlotsViewAuthoringToolbar.inherited('init', this, arguments);
			this.dataSlotsView = options.dataSlotsView;
			this.isShowingPreviousView = false;
			this.isShowingNextView = false;
			this.isRemoving = false;

			this.on('flyout:hide', this.onHideFlyout.bind(this));
			this.on('toolbar:hide', this.onHideToolbar.bind(this));
		}

		onHideFlyout(event) {
			//Note that 'flyout:hide' is triggered when Flyout.close() is called
			//This is different that the 'toolbar:hide' hide event. The 'toolbar:hide' is called by the AuthoringToolbar when it destroys the flyout
			if (event instanceof $.Event) {
				// This event is triggered only when user clicks anywhere in Focuse Mode or press Escape to close and destroy the toolbar.
				this.dataSlotsView._clearToolbar();
				this.dataSlotsView._reRender();
			} else if (!this.isShowingPreviousView && !this.isShowingNextView && !this.isRemoving) {
				// Handle the case when the application manually call Flyout.close() to close the toolbar flyout
				// Currently only Filter flyouts manually call Flyout.close()
				this.dataSlotsView._setIsImplicitClosingTheToolbar(true);
			} else {
				this.dataSlotsView._clearToolbar();
			}
		}

		onHideToolbar() {
			// Trigger by the AuthoringToolbar when it destroys the current opened flyout
			if (!this.isShowingPreviousView && !this.isShowingNextView && !this.isRemoving) {
				//Only reRender the if and only if:
				//1. Not launch NextView
				//2. Not click the top banner to go back to the previous view
				//3. Not destroying this toolbar
				this.dataSlotsView._reRender();
			} else if (!this.isShowingPreviousView && !this.isShowingNextView && this.isRemoving) {
				// cover case when leaving authoringToolbar and opening MUI (i.e. calculation dialog)
				// No previous or next value to show, and we are removing toolbar, in this case make sure
				// to clear the toolbar
				this.dataSlotsView._clearToolbar();
			}
		}

		showPreviousView(...args) {
			this.isShowingPreviousView = true;
			super.showPreviousView(...args);
		}

		pushItemsOnStack(...args) {
			//This function is called when click to show NextView from the toolbar
			this.isShowingNextView = true;
			super.pushItemsOnStack(...args);
		}

		remove(...args) {
			if (!this.isRemoving) {
				this.isRemoving = true;
				super.remove(...args);
			}
		}
	}
	return DataSlotsViewAuthoringToolbar;
});
